import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button } from "react-bootstrap";

const Page500 = () => (
  <React.Fragment>
    <Helmet title="500 Error" />
    <div className="text-center">
      <h1 className="display-1 fw-bold">Napaka</h1>
      <p className="h1">Napaka na strežniku.</p>
      <p className="h2 fw-normal mt-3 mb-4">
        Na strežniku je prišlo do napake, zato ne moremo prikazati vsebine.
      </p>
      <Link to="/">
        <Button variant="primary" size="lg">
          Na prvo stran
        </Button>
      </Link>
    </div>
  </React.Fragment>
);

export default Page500;
